"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const separator_styles_1 = require("@/components/common/separator/separator.styles");
require("@/components/common/text/semantics/caption");
const shared_styles_1 = require("@/stylesheets/shared.styles");
let Separator = class Separator extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'element';
    }
    render() {
        return (0, lit_1.html) `
      <hr />
      <mm-caption><slot></slot></mm-caption>
    `;
    }
};
Separator.styles = [shared_styles_1.resetStyles, separator_styles_1.separatorStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Separator.prototype, "variant", void 0);
Separator = __decorate([
    (0, decorators_js_1.customElement)('mm-separator')
], Separator);
exports.Separator = Separator;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VwYXJhdG9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic2VwYXJhdG9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFzQztBQUN0QyxxREFBMkQ7QUFFM0QscUZBQWdGO0FBQ2hGLHNEQUFtRDtBQUNuRCwrREFBeUQ7QUFLbEQsSUFBTSxTQUFTLEdBQWYsTUFBTSxTQUFVLFNBQVEsZ0JBQVU7SUFBbEM7O1FBRXNDLFlBQU8sR0FBcUIsU0FBUyxDQUFBO0lBUWxGLENBQUM7SUFOQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7O0tBR1YsQ0FBQTtJQUNILENBQUM7O0FBUk0sZ0JBQU0sR0FBRyxDQUFDLDJCQUFXLEVBQUUsa0NBQWUsQ0FBQyxDQUFBO0FBQ0g7SUFBMUMsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7MENBQXNDO0FBRnJFLFNBQVM7SUFEckIsSUFBQSw2QkFBYSxFQUFDLGNBQWMsQ0FBQztHQUNqQixTQUFTLENBVXJCO0FBVlksOEJBQVMifQ==